import { AllegatoComunicazioneDTO } from '@framework/api-client';
import { Button } from 'antd';
import * as React from 'react';
import styled from 'styled-components';
import { useAuthDownload } from '../../../utils/download/useAuthDownload';
import { useHasDocumentsInlineViewer } from '../../documents/useHasDocumentsInlineViewer';
import { useCommunicationsContext } from '../context/CommunicationsContext';
import { ICommonCommunicationProps } from '../logic/ICommonCommunicationProps';
import { AttachmentItemView } from './AttachmentItemView';

const AttachmentLink = styled.div`
  // test
  > button {
    font-weight: 400;
    padding-left: 0;
    line-height: 1.2;
    height: auto;
    > div.ant-space {
      border-bottom: 1px solid transparent;
      :hover {
        border-bottom-color: ${props => props.theme.colorPrimary};
      }
      .ant-space-item {
        text-align: left;
      }
    }
  }
`;

export interface IAttachmentItemProps {
  attachment?: AllegatoComunicazioneDTO | null | undefined;
  id?: string | null;
  // name?: string | null;
  // after?: React.ReactNode;
  getDownloadQueryOptions: ICommonCommunicationProps<
    any,
    any
  >['getDownloadAttachmentQueryOptions'];
}

/**
 * Singolo allegato della comunicazione
 */
export function AttachmentItem(props: IAttachmentItemProps) {
  const { id, getDownloadQueryOptions, attachment } = props;

  const { procedureId } = useCommunicationsContext();
  const hasInlineViewer = useHasDocumentsInlineViewer();
  const { download, isFetching } = useAuthDownload(
    getDownloadQueryOptions,
    procedureId ? [procedureId, id!] : [id!],
    { filename: attachment?.nomeFile, showInlineViewer: hasInlineViewer },
  );

  if (!id || !attachment) return null;

  return (
    <AttachmentLink>
      <Button type="link" loading={isFetching} onClick={download}>
        <AttachmentItemView attachment={attachment} />
      </Button>
    </AttachmentLink>
  );
}
